import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './footer.component.scss';
import './about-card/about-card.component.scss';
import './app-card/app-card.component.scss';
import './contact-card/contact-card.component.scss';
import './footer-card/footer-card.component.scss';
var FooterContainer = /** @class */ (function (_super) {
    tslib_1.__extends(FooterContainer, _super);
    function FooterContainer(element) {
        return _super.call(this, element) || this;
    }
    FooterContainer.prototype.init = function () { };
    FooterContainer.prototype.bindEvents = function () { };
    return FooterContainer;
}(Base));
export { FooterContainer };



//////////////////
// WEBPACK FOOTER
// ./components/footer/footer.component.ts
// module id = 294
// module chunks = 0